// @flow
import React, { useState, useCallback } from 'react';
import { navigate } from '@reach/router';

import { inspectionGibddCostApi } from '../../lib/api';
import type { UserAccess, InspectionGibddCost } from '../../lib/types';
import { formatDateTimeToString } from '../../lib/helpers';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';
import {
  approveTypes,
  drivingLicenseCategories,
  tractorDrivingLicenseCategories,
  vehicleTypes
} from '../../lib/enum';
import { getBreadCrumbsByUrlForCard } from '../../lib/autoBreadcrumbs';

const { Field } = Card;

type InnerProps = {
  data: InspectionGibddCost
};

type PageProps = {
  id: string,
  userAccess: UserAccess[]
};

const entryPointPath = '/admin/inspection-gibdd-cost/';

const licenseCategories = {
  ...drivingLicenseCategories,
  ...tractorDrivingLicenseCategories
};
const InnerForm = (props: InnerProps) => {
  return (
    <>
      <Grid gutter="16px">
        <GridItem>
          <Field label="Подразделение">{props.data.orgUnitName}</Field>
        </GridItem>
        <GridItem>
          <Field label="Стоимость за один осмотр (работа)">
            {props.data.cost}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Категория транспортного средства">
            {licenseCategories[props.data.rightsCategory]}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Тип ТС которые подлежат прохождению ТО в ГИБДД">
            {vehicleTypes[props.data.vehicleType]}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Периодичность прохождения ТО в ГИБДД для Типа ТС (мес)">
            {props.data.maintenanceIntervals}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Статус">{approveTypes[props.data.status]}</Field>
        </GridItem>
        <GridItem>
          <Field label="Дата начала">
            {formatDateTimeToString(props.data.startDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата окончания">
            {formatDateTimeToString(props.data.endDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
      </Grid>
    </>
  );
};

export default withUserAccess((props: PageProps) => {
  const [data: InspectionGibddCost, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForCard(entryPointPath, data.id);

  const canEdit = props.userAccess.some(access =>
    addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit
      ? async () => {
          await inspectionGibddCostApi.delete(data.id);
          await navigate(`${entryPointPath}`);
        }
      : false,
    edit: canEdit
      ? async () => await navigate(`${entryPointPath}edit/${data.id}`)
      : false
  };

  const onFetch = useCallback(async () => {
    setData(await inspectionGibddCostApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость ТО ГИБДД',
        access
      }}
      onFetch={onFetch}
    >
      <InnerForm data={data} />
    </CommonCardPage>
  );
});
